class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/call-recordings`;
    }
    /**
     * Deletes company call recordings by their IDs. *Please note:* This method deletes the recording file itself,
     * not the record of it in the call log.
     *
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-recordings
     * Rate Limit Group: Heavy
     * App Permission: EditCallLog
     * User Permission: EditCompanyCallRecordings
     */
    async delete(callRecordingIds, restRequestConfig) {
        const r = await this.rc.delete(this.path(), callRecordingIds, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
